import type {Values} from '@wix/devzai-utils-common';

/**
 * Visual style of a page's social-link buttons.
 *
 * - `Plain` — the icon is rendered without any chrome plate (a bare clickable icon).
 *   This is the default and reproduces the original look that existed before the
 *   button-style feature was introduced.
 * - The remaining values mirror {@link DopeStandardActionButtonSkin} and instruct the
 *   renderer to wrap the icon in the standard action-button chrome with that skin.
 *   Roundness is configurable via {@link BymoPageSocialLinksProps.socialLinksCustomActionButtonTemplate}.
 *
 * The skin field stored on `socialLinksCustomActionButtonTemplate.templateProps` is
 * intentionally NOT consulted at render time for social links — this enum is the single
 * source of truth for the rendered skin.
 */
export const BymoPageSocialLinksButtonStyle = {
    Plain: 'Plain',
    Standard: 'Standard',
    Inverted: 'Inverted',
    HardShadow: 'HardShadow',
    Gradient: 'Gradient',
    Glass: 'Glass',
} as const;

export type BymoPageSocialLinksButtonStyle = Values<typeof BymoPageSocialLinksButtonStyle>;
